import React from 'react'
import { Button, Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { useHistory } from 'react-router-dom'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import Dialog from 'redesign/components/molecules/dialog/dialog'
import Header from 'redesign/components/organisms/Header'
import Page from 'redesign/components/templates/Page'
import routes from 'services/RoutesProvider/routes'

const SecureConnectionDialogPage: React.FC = () => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()
  const history = useHistory()

  return (
    <RedesignThemeWrapper>
      <Page
        header={
          <Header
            backgroundColor={palette.background.default}
            withoutDivider
            middleContent={<Typography variant="subtitle1">{t('secureConnection.dialog.hiddenContent')}</Typography>}
          />
        }
        hideNativeNavigation
        fullContentHeight
        fullContentWidth
        showHamburgerHeader={false}
      >
        <Dialog
          actions={
            <>
              <Button data-testid="cancel-dialog-btn" onClick={() => history.replace(routes.securitySetup)}>
                {t('secureConnection.dialog.cancel')}
              </Button>
              <Button color="secondary" onClick={() => history.goBack()}>
                {t('common.close')}
              </Button>
            </>
          }
          open
          title={t('secureConnection.dialog.title')}
        >
          <Typography>{t('secureConnection.dialog.body')}</Typography>
        </Dialog>
      </Page>
    </RedesignThemeWrapper>
  )
}

export default SecureConnectionDialogPage
